import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { DocumentTemplate } from "../../models/ConsentDocument";
import { axiosClient } from "../axiosClient";

export const fetchDocumentTemplates = createAsyncThunk('docusign/documentTemplates', async () => {
    const response: AxiosResponse<DocumentTemplate[]> = await (await axiosClient()).get(`/docusign/templates`);
    return response.data;
});

export const createDocumentTemplate = createAsyncThunk('docusign/createDocumentTemplate', async (params: {data: DocumentTemplate}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<DocumentTemplate> = await (await axiosClient()).post(`/docusign/templates`, {...params.data});
        return response.data
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const updateDocumentTemplate = createAsyncThunk('docusign/updateDocumentTemplate', async (params: {data: DocumentTemplate, templateId: number}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<DocumentTemplate> = await (await axiosClient()).patch(`/docusign/templates/${params.templateId}`, {...params.data});
        return response.data
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const deleteDocumentTemplate = createAsyncThunk('docusign/deleteDocumentTemplate', async (params: {templateId: number}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<DocumentTemplate[]> = await (await axiosClient()).delete(`/docusign/templates/${params.templateId}`);
        return response.data
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});